import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Sidebar from "../sidebar/Sidebar";
import "./mainLayout.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import IdleTimer from "../IdleTimer";
import SubscriptionExpiredDialog from "../SubscriptionExpiredDialog";
import SubscriptionSuspendedDialog from "../SubscriptionSuspendedDialog";
import MobileBottomBar from "../mobileBottomBar/MobileBottomBar";

// Layout with Navbar & Footer
export default function MainLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { darkMode } = useSelector((state) => state.theme);
  const isLoggedOut = useSelector((state) => state.user.isLoggedOut);
  const currentSchool = useSelector((state) => state.school.currentSchool);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const isSuspended = currentSchool?.subscription?.status === "Suspended";

  // Close sidebar whenever the route changes
  useEffect(() => {
    setOpen(false);
  }, [location]);

  useEffect(() => {
    if (open) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [open]);

  useEffect(() => {
    if (currentSchool?.subscription?.status === "Expired") {
      setSubscriptionDialogOpen(true);
    }
  }, [currentSchool?.subscription?.status]);

  return (
    <div className="mainLayout">
      {/* Mount IdleTimer only when logged in */}
      {!isLoggedOut && <IdleTimer />}

      {/* Hamburger for mobile */}
      <button
        style={{ color: darkMode ? "#fff" : "#000" }}
        className="sidebar-toggle"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>
      {open && (
        <div
          className={`overlay ${open ? "active" : ""}`}
          onClick={() => setOpen(false)}
        />
      )}
      <aside className={`sidebarContainer ${open ? "open" : ""}`}>
        <Sidebar />
      </aside>
      <nav className="navbarContainer">
        <Navbar />
      </nav>
      <main className="mainContainer">
        <Outlet />
      </main>
      {!isLoggedOut && <MobileBottomBar />}
      <SubscriptionExpiredDialog
        open={subscriptionDialogOpen}
        onClose={() => setSubscriptionDialogOpen(false)}
      />
      {isSuspended && <SubscriptionSuspendedDialog />}
      {/* <footer>I am footer</footer> */}
    </div>
  );
}
